<template>
  <nav
    class="
      bg-white
      border-gray-200
      px-2
      sm:px-4
      py-2.5
      rounded
      dark:bg-gray-900/70
    "
  >
    <div
      class="
        container
        flex flex-wrap
        justify-between
        items-center
        mx-auto
        flex-row
      "
    >
      <div md:order-1>
        <router-link to="/" class="flex">
          <span
            class="
              self-center
              whitespace-nowrap
              dark:text-white
              text-xl
              font-bold
              w-24
            "
            >Home</span
          >
        </router-link>
      </div>
      <div
        class="justify-between items-center w-full md:flex md:w-auto md:order-2"
      >
        <SearchBar></SearchBar>
      </div>
      <div class="flex md:order-3">
        <LoginButton />
      </div>
    </div>
  </nav>
  <bubble-background />
  <WarningPop ref="WarningPop" />
  <ErrorPop ref="ErrorPop" />
  <SuccessPop ref="SuccessPop" />
  <InfoPop ref="InfoPop" />
  <router-view v-slot="{ Component }">
    <transition name="fade" mode="out-in">
      <component :is="Component" />
    </transition>
  </router-view>
</template>


<script>
import SearchBar from "./components/SearchBar.vue";
import BubbleBackground from "./components/BubbleBackground.vue";
import LoginButton from "./components/LoginButton.vue";
// import axios from "axios";
import store from "./store";
import WarningPop from "./components/WarningPop.vue";
import ErrorPop from "./components/ErrorPop.vue";
import SuccessPop from "./components/SuccessPop.vue";
import InfoPop from "./components/InfoPop.vue";

export default {
  components: {
    SearchBar,
    BubbleBackground,
    LoginButton,
    WarningPop,
    ErrorPop,
    SuccessPop,
    InfoPop,
  },
  computed: {
    showWarning() {
      return store.getters.showWarning;
    },
    showSuccess() {
      return store.getters.showSuccess;
    },
    showError() {
      return store.getters.showError;
    },
    showInfo() {
      return store.getters.showInfo;
    },
    warningText() {
      return store.getters.warningText;
    },
    successText() {
      return store.getters.successText;
    },
    errorText() {
      return store.getters.errorText;
    },
    infoText() {
      return store.getters.infoText;
    },
  },
  watch: {
    showWarning(show) {
      if (show) {
        this.$refs.WarningPop.showMessage(2000, this.warningText);
        store.dispatch("setWarningOff");
      }
    },
    showError(show) {
      if (show) {
        this.$refs.ErrorPop.showMessage(2000, this.errorText);
        store.dispatch("setErrorOff");
      }
    },
    showSuccess(show) {
      if (show) {
        this.$refs.SuccessPop.showMessage(2000, this.successText);
        store.dispatch("setSuccessOff");
      }
    },
    showInfo(show) {
      if (show) {
        this.$refs.InfoPop.showMessage(2000, this.infoText);
        store.dispatch("setInfoOff");
      }
    },
  },
  mounted() {},
  beforeCreate() {
    store.dispatch("tryLogin");
  },
  created() {},
};
</script>


<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

body {
  background: rgb(0, 0, 0);
  margin: 0;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

nav {
  position: absolute;
  width: 100%;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
